module.exports = __webpack_public_path__ + "static/media/tutorial-card-3.f76d387e.png";